const OrganizationType = {
  '9897d7ec-ea33-4053-930e-5d899cd0ab87': 'Brusque'
}
export default OrganizationType
